import ImageArticleCardSkeleton from '@/components/skeletons/ImageArticleCardSkeleton';

const AuthorProfileSkeleton = () => {
  return (
    <div role='status' className='space-y-8 animate-pulse mx-auto'>
      <div className='mb-8'>
        <div className='justify-center w-full h-72 bg-gray-200 relative'>
          <div className='absolute top-0 left-0 w-full h-full'>
            <div className='flex flex-col h-full justify-center items-center'>
              <div className='h-6 bg-gray-400 rounded-full w-64 mb-4'></div>
            </div>
          </div>
        </div>
        <div className='container px-4 mx-auto'>
          <div className='w-full grid grid-cols-1 md:grid-cols-3 gap-8 mt-8'>
            <ImageArticleCardSkeleton />
            <ImageArticleCardSkeleton />
            <ImageArticleCardSkeleton />
          </div>
        </div>
      </div>
      <span className='sr-only'>Loading...</span>
    </div>
  );
};

export default AuthorProfileSkeleton;
